<template>
    <div class="confirm-information">
        <!-- :show-close="false" -->
        <el-dialog :visible.sync="centerDialogVisible" width="30%" center :close-on-click-modal="false"
            :close-on-press-escape="false" :show-close="false">
            <div class="confirm-information-box">
                <div class="confirm-information-title">请确认信息</div>
                <div class="confirm-information-content">
                    <div class="info-item">
                        <div class="info-name-title flex-align-center">姓名：</div>
                        <el-input size="large" v-model="nameInput" placeholder="请输入姓名"
                            :disabled="ModificationType"></el-input>
                    </div>
                    <div class="info-item ">
                        <div class="info-name-title flex-align-center">学校：</div>
                        <el-select v-model="schInput" size="large" filterable remote reserve-keyword placeholder="请输入学校全称"
                            :remote-method="getuserRegistrationOptionSchool" :loading="Sch_loading"
                            :disabled="ModificationType" clearable @change="schoolChange">
                            <el-option v-for="item in filteredSchools" :key="item.id" :label="item.name"
                                :value="item.name" />
                        </el-select>
                    </div>
                    <div class="info-item ">
                        <div class="info-name-title flex-align-center">班级：</div>
                        <el-cascader ref="myCascader" v-model="selectedClass" placeholder="请选择班级" size="large"
                            :options="classList" :props="props" collapse-tags clearable :disabled="ModificationType"
                            @change="handleChange"></el-cascader>
                    </div>
                    <div class="info-item flex-align">
                        <div class="info-name-title flex-align-center"></div>
                        <div class="tags-container flex-align" v-if="ClassNamesByIdList.length > 0">
                            <el-tag type="success" v-for="(item, index) in ClassNamesByIdList" :key="index">{{ item }}
                            </el-tag>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer flex-align-center" v-if="ModificationType">
                <div class="Confirm Confirm-btn footer-btn flex-align-center" @click="confirm">确认无误</div>
                <div class="ModifyInformation Mod-btn footer-btn flex-align-center" @click="ModifyInformation">修改信息</div>
            </span>
            <span slot="footer" class="dialog-footer flex-align-center" v-else>
                <div class="Confirm Confirm-btn footer-btn flex-align-center" @click="confirm">确认修改</div>
                <div class="ModifyInformation Mod-btn footer-btn flex-align-center" @click="cancel">取消</div>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['UserInfo_data'],
    data() {
        return {
            centerDialogVisible: false,
            nameInput: '',
            schInput: '',
            sch_Idlit: [],
            class_Idlit: [],
            ModificationType: true,
            Sch_loading: false,
            props: {
                multiple: true,
                emitPath: false,
                value: 'id',
                label: 'name',
                children: 'children'
            },
            schoolList: [],
            filteredSchools: [],
            classList: [],
            selectedClass: '',
            postclassList: null,
            ClassNamesByIdList: []
        };
    },
    // 计算属性
    computed: {

    },
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        async openDialog(data) {
            //判断个人信息是否学校是否为空
            this.nameInput = this.UserInfo_data.name; //当前账号姓名
            this.RequestCollection();
            // await this.getschoolList();//获取所有学校列表
            // if (this.UserInfo_data.schoolId != null) {
            //     await this.getSchoolIdbyUserId();//获取当前账号学校id列表
            //     await this.getclassByTree();//通过学校id获取班级列表
            //     await this.getClassIdbyUserId();//获取当前账号班级id列表
            // }
            this.centerDialogVisible = true;
            if (data.isNeedUp) {
                this.ModificationType = false;
            }
        },
        async RequestCollection() {
            await this.getschoolList();//获取所有学校列表
            if (this.UserInfo_data.schoolId != null) {
                await this.getSchoolIdbyUserId();//获取当前账号学校id列表
                await this.getclassByTree();//通过学校id获取班级列表
                await this.getClassIdbyUserId();//获取当前账号班级id列表
            }
        },
        async getSchoolIdbyUserId() {//获取当前账号学校id列表
            let resData = await this.$Api.Home.getSchoolIdbyUserId();
            this.sch_Idlit = resData.data;
            this.getschoolData(resData.data);
        },
        async getschoolList() {//获取所有学校列表
            let resData = await this.$Api.Home.getschoolList();
            this.schoolList = resData.data;
        },
        getschoolData(data) { //获取默认学校名称列表
            let selectedSchools = this.schoolList.filter(school => data.includes(school.id)).map(school => school.name);
            this.schInput = selectedSchools[0];
        },
        schoolChange(data) {
            this.selectedClass = '';
            this.classList = [];
            this.ClassNamesByIdList = [];
            const targetSchool = this.schoolList.find(school => school.name == data);
            const schoolId = targetSchool ? targetSchool.id : null;
            this.sch_Idlit = [schoolId];
            if (schoolId != null) {
                this.getclassByTree();//通过学校id获取班级列表
            }
        },
        async getClassIdbyUserId() {//获取当前账号学校id列表
            let resData = await this.$Api.Home.getClassIdbyUserId();
            this.class_Idlit = resData.data;
            this.selectedClass = this.class_Idlit;
            this.ClassNamesByIdList = this.findClassNamesByIds(this.classList, this.selectedClass)
        },
        getsclassData(nodeList, targetIdSet) { //获取默认班级名称列表
            const result = [];
            for (const node of nodeList) {
                if (targetIdSet.has(node.id)) {
                    result.push(node);
                }
                if (node.children && Array.isArray(node.children) && node.children.length > 0) {
                    const foundInChildren = this.getsclassData(node.children, targetIdSet);
                    result.push(...foundInChildren);
                }
            }

            return result;
        },
        async getclassByTree() {//通过学校id获取班级列表
            let data = {
                schoolList: this.sch_Idlit,
            }
            try {
                let resData = await this.$Api.Home.getclassByTree(data);
                if (resData && resData.data) {
                    this.classList = resData.data;
                }
            } catch (error) {
                console.error('接口请求错误:', error);
            }

        },
        async getuserRegistrationOptionSchool(query) {
            if (query !== '') {
                const filteredSchools = this.schoolList.filter(school =>
                    school.name.includes(query)
                );
                this.filteredSchools = filteredSchools;
            } else {
                // 如果搜索关键字为空，返回所有学校
                this.filteredSchools = [];
            }
        },
        sch_DataProcessing() {//处理提交学校数据
            const result = this.schoolList
                .filter(school => this.schInput.includes(school.name))
                .map(school => school.id);
            return result;

        },
        class_DataProcessing() {//处理提交班级数据
            let result = [];
            this.selectedClass.forEach(path => {
                const [schoolId, gradeId, classId] = path;
                // 在 list 中查找匹配的学校
                const school = this.classList.find(s => s.id === schoolId);
                if (!school || !school.children) return;
                // 在学校中查找匹配的年级
                const grade = school.children.find(g => g.id === gradeId);
                if (!grade || !grade.children) return;
                // 在年级中查找匹配的班级
                const clazz = grade.children.find(c => c.id === classId);
                if (!clazz) return;

                // 构造结果对象，拼接年级名 + 班级名
                result.push({
                    id: clazz.id,
                    name: grade.name + clazz.name,  // 如：一年级1班
                    // 你可以根据需要添加其他字段，如 gradeId, schoolId 等
                    children: clazz.children,
                    grade: clazz.grade,
                    number: clazz.number,
                });
            });
            return result;
        },
        async bindClass() {
            if (this.nameInput == '') {
                this.$message({
                    message: '姓名不能为空',
                    type: 'error',
                    customClass: 'my-message',
                    center: true
                });
                return;
            } else if (this.schInput == '') {
                this.$message({
                    message: '学校不能为空',
                    type: 'error',
                    customClass: 'my-message',
                    center: true
                });
                return;
            } else if (this.selectedClass == '') {
                this.$message({
                    message: '班级不能为空',
                    type: 'error',
                    customClass: 'my-message',
                    center: true
                });
                return;

            }
            if (this.postclassList == null) {
                const targetIdSet = new Set(this.class_Idlit); // new Set([1, 2, 3])
                const foundNodes = this.getsclassData(this.classList, targetIdSet);
                this.postclassList = foundNodes;
            }
            // 处理提交信息数据
            let data = {
                teacherName: this.nameInput,
                schoolList: this.sch_DataProcessing(),
                classList: this.postclassList,
            };
            console.log('bindClass data', data);
            try {
                let resData = await this.$Api.Home.bindClass(data);
                if (resData && resData.data) {
                    this.$message({
                        message: '提交成功',
                        type: 'success',
                        customClass: 'my-message',
                        center: true
                    });
                    this.centerDialogVisible = false;
                    this.ModificationType = true;
                    this.$emit('custom-event');

                }
            } catch (error) {
                console.error('接口请求错误:', error);
            }

        },
        confirm() {//提交信息
            this.bindClass();
        },
        ModifyInformation() {//修改信息
            this.ModificationType = false;
        },
        cancel() {//取消
            this.RequestCollection();
            this.ModificationType = true;

        },
        handleChange(data) {
            const checkedNodes = this.$refs.myCascader.getCheckedNodes();
            let dataArr = [];
            let tagData = [];
            for (let i = 0; i < checkedNodes.length; i++) {
                if (checkedNodes[i].level == 3) {
                    let Item = checkedNodes[i].data;
                    dataArr.push(Item)
                    tagData.push(checkedNodes[i].label)
                }
            }
            this.postclassList = dataArr;
            // this.ClassNamesByIdList = this.findClassNamesByIdsPuls(dataArr)
            this.ClassNamesByIdList = tagData;
        },
        findClassNamesByIds(data, idArray) {
            const map = new Map();
            const traverse = (nodes) => {
                for (let item of nodes) {
                    if (!item.children || !Array.isArray(item.children)) {
                        map.set(item.id, item.name);
                    }
                    if (item.children && Array.isArray(item.children)) {
                        traverse(item.children);
                    }
                }
            };
            traverse(data);
            return idArray.map(id => map.get(id)).filter(name => name != null);
        },
        findClassNamesByIdsPuls(idArray) {
            let gradeName = {
                1: '一年级',
                2: '二年级',
                3: '三年级',
                4: '四年级',
                5: '五年级',
                6: '六年级',
            }
            let nameArr = [];
            for (let index = 0; index < idArray.length; index++) {
                const ids = idArray[index].id;
                if (ids == 0) {
                    nameArr.push(gradeName[idArray[index].grade] + idArray[index].name)
                } else {
                    nameArr.push(idArray[index].name)
                }

            }
            return nameArr;
        },


    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() { },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style scoped lang="less">
/* 全局样式中 */
::v-deep.el-message--error {
    width: 100px !important;
    width: auto !important;
    /* 自定义宽度 */
    // min-width: auto !important;
    /* 防止被最小宽度覆盖 */
}

::v-deep.confirm-information {
    .el-dialog__header {
        padding: 0 !important;
    }



    .confirm-information-box {

        // border: 1px solid #000;
        display: flex;
        flex-direction: column;
        align-items: center;


        .confirm-information-title {
            font-size: 18px;
            color: #000;
            font-weight: bold;
            padding: 10px 0;
            margin-bottom: 40px;
        }

        .confirm-information-content {
            width: 500px;
            // height: 250px;
            // border: 1px solid #000;

            .info-item {
                margin-bottom: 20px;
                display: flex;
                align-items: center;

                // border: 1px solid #000;
                // justify-content: space-between;
            }

            .el-cascader__tags {
                .el-tag__close {
                    display: none !important;
                }
            }

            // .el-cascader-node.in-active-path{
            //     color: #21bd99 !important;
            // }
            .tags-container {
                width: 100%;
                // border: 1px solid #000;
                flex-wrap: wrap;
                height: auto !important;

                .el-tag {
                    margin: 5px 10px;
                    border: 1px solid #7fdbc6;
                    background-color: rgba(179, 240, 226, 0.1);
                    color: #21bd99;
                }
            }

            .info-name-title {
                width: 100px;
                // height: 35px;
                // border: 1px solid #000;
                font-size: 17px;
                font-weight: bold;
                color: #666666;
                // border: 1px solid #000;
            }
        }
    }

    .footer-btn {
        width: 110px;
        height: 40px;
        // border: 1px solid #000;
        font-size: 16px;
        margin: 0 10px;
        margin-bottom: 20px;
        border-radius: 8px;
    }

    .Confirm-btn {
        background: #21BD99;
        color: #fff;
        border: 1px solid #21BD99;
        cursor: pointer;
    }

    .Mod-btn {
        background: #fff;
        color: #8b8888;
        border: 1px solid #7fdbc6;
    }

    .el-input__inner:focus {
        border-color: #21BD99;
    }

    .el-input {
        width: 100% !important;
    }

    .el-select {
        width: 100% !important;
    }

    .el-cascader {
        width: 100% !important;
    }

    .el-input__inner:focus {
        border-color: #21BD99;
    }

    .el-cascader-node.is-active {
        color: #21BD99 !important;
    }

    .el-checkbox__inner {
        background-color: #21BD99 !important;
        color: #000;
    }
}
</style>